import {
  Field,
  withTypes,
} from 'react-final-form';
import classNames from 'classnames';
import { t } from 'ttag';

import { FormError } from '@ui/FormError';
import {
  composeValidators,
  required,
  validateIsEmail,
} from '@utils/validators';
import Title from '@ui/Title';
import Input from '@ui/Input';
import { Button } from '@ui/Button';
import Modal, { ModalProps } from '@ui/Modal/NModal';

import CollectionEmails from './images/collectionEmails.svg';

import s from './CollectingEmailsForm.sss';

// types
export type FormData = {
  email: string
};

type CollectingEmailsFormProps = ModalProps & {
  onSubmit: (arg1: FormData) => void;
  className?: string;
};

export const CollectingEmailsForm: React.FC<CollectingEmailsFormProps> = ({
  onSubmit,
  className,
  isOpen,
  onRequestClose,
  onAfterOpen,
}) => {
  const { Form } = withTypes<FormData>();
  return (
    (
      <Modal
        onAfterOpen={onAfterOpen}
        className={classNames(s.modal, className)}
        withClose={true}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
      >
        <img src={CollectionEmails} alt="collectionEmails" />
        <div className={s.text}>
          <Title
            type="h3"
            bold={false}
            className={s.title}
          >
            {t`Залиште свою email-адресу`}
          </Title>
          <p>{t`Ми повідомимо вам, коли знизиться ціна на товар`}</p>
        </div>
        <Form
          onSubmit={onSubmit}
          render={({
            submitError, handleSubmit, submitting, pristine,
          }) => (
            <form className={s.form} onSubmit={handleSubmit}>

              <Field
                name="email"
                validate={composeValidators(required, validateIsEmail)}
              >
                {({ input, meta }) => (
                  <>
                    <Input
                      {...input}
                      type="text"
                      className={s.input}
                      placeholder={t`Ваша email-адреса`}
                    />
                    {meta.error && meta.touched
                  && <FormError>{meta.error}</FormError>}
                    {meta.submitError
                  && <FormError>{meta.submitError}</FormError>}
                    {submitError
                  && <FormError>{submitError}</FormError>}
                  </>
                )}
              </Field>

              <Button
                type="submit"
                disabled={submitting || pristine}
                className={s.submitButton}
              >
                {t`Хочу цей товар дешевше`}
              </Button>
            </form>
          )}
        />
      </Modal>
    )
  );
};
